<template>
  <div class="maccontainer _maccontainer">
    <doorList :newStyle="newStyle"></doorList>
    <!-- Swiper -->
    <div class="swiper-position">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in swiperData"
            :key="index"
          >
            <video
              :src="item.url"
              controls
              :id="'video' + index"
              class="video"
              loop
              v-if="item.type.includes('VIDEO')"
            ></video>
            <img :src="item.url" alt="" v-else-if="item.type.includes('PIC')" />
          </div>
        </div>
        <!-- Add Pagination -->
        <div class="swiper-pagination"></div>
        <!-- Add Arrows -->
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
      </div>
      <!-- link -->
      <div class="link" @mouseenter="stopLinkSwiper" @mouseleave="startLinkSwiper">
        <div class="swiper-container swiper-link">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in linkData"
              :key="index"
            >
              <!-- <marquee loop='1'> -->
                <a :href="item.url" target="_blank">{{ item.name }}</a>
              <!-- </marquee> -->
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import doorList from "@/components/doorList";

import "swiper/dist/js/swiper";
import Swiper from "swiper";
export default {
  name: "foisonDoor",
  components: {
    doorList,
  },
  data() {
    return {
      swiperData: [],
      linkData: [],
      swiper: null,
      linkSwiper: null,
      newStyle: [
        {
          id: 1,
          name: "2022荣耀庭院门",
          title: "新款",
          img: require("../../assets/luxuryArmourDoor/newStyle.png"),
          listImg: [
            {
              id: 1,
              imgLink: require("../../assets/courtyardGloryDoor/courtyardGloryDoor1.jpg"),
              understand: true,
            },
            {
              id: 3,
              imgLink: require("../../assets/courtyardGloryDoor/courtyardGloryDoor3.jpg"),
              understand: false,
            },
            {
              id: 4,
              imgLink: require("../../assets/courtyardGloryDoor/courtyardGloryDoor4.jpg"),
              understand: false,
            },
            {
              id: 5,
              imgLink: require("../../assets/courtyardGloryDoor/courtyardGloryDoor5.jpg"),
              understand: false,
            },
            {
              id: 2,
              imgLink: require("../../assets/courtyardGloryDoor/courtyardGloryDoor2.jpg"),
              understand: false,
            },
          ],
        },
      ],
    };
  },
  mounted() {
    this.getDoorList();
  },
  methods: {
    stopLinkSwiper(){
      this.linkSwiper.autoplay.stop();
    },
    startLinkSwiper(){
      this.linkSwiper.autoplay.start();
    },
    newSwipoer() {
      let _this = this;
      this.swiper = new Swiper(".swiper-container", {
        spaceBetween: 30,
        centeredSlides: true,
        // autoplay: {
        //   delay: 2500,
        //   disableOnInteraction: false,
        // },
        observer: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChange: function () {
            // console.log(_this.swiper)
            let currentIndex = _this.swiper.activeIndex;
            for (let i in _this.swiperData) {
              if (_this.swiperData[i].type.includes("VIDEO")) {
                let video = document.getElementById(`video${i}`);
                video.pause();
              }
            }
            console.log(_this.swiperData[currentIndex]);
            if (_this.swiperData[currentIndex].type.includes("VIDEO")) {
              let currentVideo = document.getElementById(
                `video${currentIndex}`
              );
              currentVideo.play();
            }
          },
        },
      });
    },
    initLinkSwiper() {
      this.linkSwiper = new Swiper(".swiper-link", {
        direction: "vertical",
        observer: true,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
      });
    },
    getDoorList() {
      this.$axios
        .get("/open/sale/webSiteResourceShare?seriesTypeId=7 ")
        .then((res) => {
          if (res.data.code === 0) {
            this.swiperData = res.data.data.filter(
              (item) => !item.type.includes("LINK")
            );
            this.linkData = res.data.data.filter((item) =>
              item.type.includes("LINK")
            );
            // console.log(this.swiperData);
            this.newSwipoer();
            setTimeout(()=>{
              this.initLinkSwiper();
            },300)
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
video {
  width: 100%;
  height: 100%;
}
.swiper-position {
  width: 300px;
  height: 300px;
  background: #fff;
  position: fixed;
  right: 20px;
  top: 100px;
  opacity: 0.4;
  .swiper-container {
    width: 100%;
    height: 300px;
    .swiper-wrapper {
      width: 100%;
      height: 300px;
      .swiper-slide {
        height: 100%;
        img {
          width: 100%;
        }
      }
    }
  }
  .link {
    padding-top: 10px;
  }
}
.swiper-position:hover {
  right: 40px;
  opacity: 1;
  transform: scale(1.1);
  box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s cubic-bezier(0, 0, 0.5, 1);
}
// }
</style>



// WEBPACK FOOTER //
// src/page/foisonDoor/foisonDoor.vue